
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"14px","height":"13px","viewBox":"0 0 14 13","version":"1.1"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"surface1"}},[_c('path',{staticStyle:{"fill-rule":"nonzero","fill":"rgb(21.176471%,21.176471%,21.176471%)","fill-opacity":"1","stroke-width":"0.2","stroke-linecap":"butt","stroke-linejoin":"miter","stroke":"rgb(21.176471%,21.176471%,21.176471%)","stroke-opacity":"1","stroke-miterlimit":"4"},attrs:{"d":"M 1.410156 12.582031 C 1.515625 12.625 1.628906 12.648438 1.738281 12.648438 L 1.761719 12.648438 C 1.976562 12.640625 2.183594 12.550781 2.34375 12.390625 L 4.535156 10.164062 L 11.261719 10.164062 C 12.289062 10.164062 13.125 9.328125 13.125 8.300781 L 13.125 2.265625 C 13.125 1.238281 12.289062 0.398438 11.261719 0.398438 L 2.738281 0.398438 C 1.710938 0.398438 0.875 1.238281 0.875 2.265625 L 0.875 11.785156 C 0.875 12.140625 1.082031 12.445312 1.410156 12.582031 Z M 1.410156 12.582031 L 1.445312 12.488281 Z M 2.738281 1.113281 L 11.261719 1.113281 C 11.894531 1.113281 12.410156 1.628906 12.410156 2.265625 L 12.410156 8.300781 C 12.410156 8.933594 11.894531 9.453125 11.261719 9.453125 L 4.386719 9.453125 C 4.289062 9.453125 4.199219 9.488281 4.132812 9.558594 L 1.835938 11.886719 C 1.773438 11.953125 1.703125 11.929688 1.679688 11.921875 C 1.65625 11.910156 1.589844 11.875 1.589844 11.785156 L 1.589844 2.265625 C 1.589844 1.628906 2.105469 1.113281 2.738281 1.113281 Z M 2.738281 1.113281 "}})])])
          )
        }
      }
    